import axios, { AxiosHeaders, AxiosResponse } from 'axios';
import { supabase } from 'supabase/Client';

const getAxiosInstance = (headers?: AxiosHeaders, authenticated?: boolean) => {
  const systemHeader = new AxiosHeaders();
  systemHeader.set('ngrok-skip-browser-warning', true);

  const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 300000,
    headers: {
      ...systemHeader,
      ...headers,
    },
  });

  if (authenticated) {
    instance.interceptors.request.use(
      async config => {
        const {
          data: { session },
        } = await supabase.auth.getSession();

        if (session?.access_token) {
          config.headers.Authorization = `Bearer ${session.access_token}`;
        }

        return config;
      },
      error => Promise.reject(error),
    );
  }

  return instance;
};

export const post = (
  path: string,
  payload?: any,
  headers?: any,
): Promise<AxiosResponse<any>> => {
  const instance = getAxiosInstance(headers);
  return instance.post(path, payload);
};

export const get = (
  path: string,
  headers?: any,
): Promise<AxiosResponse<any>> => {
  const instance = getAxiosInstance(headers);
  return instance.get(path);
};

export const put = (
  path: string,
  payload: any,
  headers?: any,
): Promise<AxiosResponse<any>> => {
  const instance = getAxiosInstance(headers);
  return instance.put(path, payload);
};

export const deleteReq = (
  path: string,
  headers?: any,
): Promise<AxiosResponse<any>> => {
  const instance = getAxiosInstance(headers);
  return instance.delete(path);
};

export const authenticatedPost = (
  path: string,
  payload?: any,
  headers?: any,
): Promise<AxiosResponse<any>> => {
  const instance = getAxiosInstance(headers, true);
  return instance.post(path, payload);
};

export const authenticatedGet = (
  path: string,
  headers?: any,
): Promise<AxiosResponse<any>> => {
  const instance = getAxiosInstance(headers, true);
  return instance.get(path);
};

export const authenticatedPut = (
  path: string,
  payload?: any,
  headers?: any,
): Promise<AxiosResponse<any>> => {
  const instance = getAxiosInstance(headers, true);
  return instance.put(path, payload);
};
export const authenticatedDelete = (
  path: string,
  headers?: any,
): Promise<AxiosResponse<any>> => {
  const instance = getAxiosInstance(headers, true);
  return instance.delete(path);
};
